import { ContactSellerModal } from '@bark/bark-core';
import BuyerApi from '../helpers/buyer-api';
import ListUtility from '../helpers/list-utility';
import BrowseListUrlHandler from '../helpers/browse-list-url-handler';
import listFlowExperimentsTracking from '../helpers/list-flow-experiments-tracking';
import InitiateNewBark from '../helpers/initiate-new-bark';
import TenderUpsellModal from '../helpers/modals/tender-upsell-modal';
import MasterBindings from '../helpers/misc/master';
import {
	registerHBPartials,
	registerSplitListPartials,
} from '../helpers/template-management';

export default async function () {
	const buyerApi = BuyerApi();
	const browseUrlHandler = BrowseListUrlHandler();

	let { getBrowseProfessionalList, getProviderNounPlural } = window.browseFunctions;

	let state = {
		shouldAnimate: false,
		isAnimating: false,
		shouldShowRequestQuotesFromAll: true,
		loadingStateIndex: 0,
		fullSellerList: [],
		projectDetail: null,
		notInterestedSellers: [],
		buyerDeclinedSellers: [],
		requestedQuoteFromAllSellers: [], // An array to contain the seller IDs that 'request from all' was used on
		moreSuggestionsAvailable: false,
		numberSellersAbleToHaveQuoteRequested: 0,
		countRequestedQuoteThisPageload: 0,
		browseListTitle: null,
	};

	let listUtilityHandler = ListUtility(
		'',
		state,
		browseUrlHandler,
		isSimpleSeller,
		getBrowseProfessionalList,
	);

	const {
		addManagedSkeletonContainer,
		handleBrowseDataLoadedSteps,
		getBrowseDataForPageAndRender,
		bindBrowseListeners,
		browseErrorRender,
	} = listUtilityHandler;

	const init = () => {
		try {
			addManagedSkeletonContainer('seller-list', 10);
			$('#seller-list').trigger('startSkeleton');
			registerHBPartials([
				'avatar',
				'top-information-row',
				'simple-mobile-card-toprow',
				'simple-tablet-card-toprow',
				'simple-mobile-seller-card',
				'simple-desktop-seller-card',
				'response-time-col-mobile',
				'hire-count-col-mobile',
				'rating-stars-col-mobile',
				'response-time-col-desktop',
				'hire-count-col-desktop',
				'rating-stars-col-desktop',
			]);
			// needed for pagination etc
			registerSplitListPartials();

			state.browseListTitle = getProviderNounPlural();
			const { p, ls } = browseUrlHandler.getUrlParams();
			getBrowseProfessionalList(
				(browseList) => {
					let { data: project } = browseList;
					state.projectDetail = project;
					// set up an load browse data
					handleBrowseDataLoadedSteps();
					state.browseList = browseList;
					getBrowseDataForPageAndRender('project-seller-list', TenderUpsellModal);
				},
				(error) => {
					browseErrorRender();
					bugsnagClient &&
						bugsnagClient.notify(new Error('Error on handling browse promise'), {
							metaData: { error: error },
						});
				},
				{
					page: { number: p },
					sort: ls ?? '-review',
				},
			);
		} catch (err) {
			bugsnagClient &&
				bugsnagClient.notify(new Error('Error on setting up browse'), {
					metaData: { error: err },
				});
		}
	};

	init();

	bindBrowseListeners({ pageName: 'browse-list' });


	$('.js-convert-tender')
		.off('click.ct')
		.on('click.ct', (e) => {
			e.preventDefault();
			browseFunctions.tracking('Browse-list - Request all');
			browseFunctions.resumeBarkModal(
				() => {},
				(err) => {
					bugsnagClient &&
						bugsnagClient.notify(new Error('Error on handling browse promise'), {
							metaData: { error: err },
						});
				},
			);
		});

	InitiateNewBark().bind();
	ContactSellerModal({
		hasActiveProject: true,
		customTracking: listFlowExperimentsTracking,
	});
	MasterBindings();
}
